import {customElement} from '@aofl/element';
import {sdoNs} from '../constants-enumerate';
import {BaseSearchLicenseFilters} from '../base-search-license-filters';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';

/**
 * @summary UserSearchLicenseFilters
 * @extends {BaseSearchLicenseFilters}
 */
@customElement('user-search-license-filters')
class UserSearchLicenseFilters extends mapStatePropertiesMixin(BaseSearchLicenseFilters) {
  static is = 'user-search-license-filters';

  filterUpdated(e) {
    const aoflProduct = e.target.product;
    this.storeInstance.commit({
      namespace: sdoNs.USER_SEARCH,
      mutationId: 'setPendingFiltersProduct',
      payload: aoflProduct
    });

    if (this.showLicenses === true) {
      const licenseId = e.target.license;
      this.storeInstance.commit({
        namespace: sdoNs.USER_SEARCH,
        mutationId: 'setPendingFiltersLicense',
        payload: licenseId
      });
    }

    const licenseStatus = e.target.licenseStatus;
    this.storeInstance.commit({
      namespace: sdoNs.USER_SEARCH,
      mutationId: 'setPendingFiltersLicenseStatus',
      payload: licenseStatus
    });
    this.dispatchEvent(new CustomEvent('changed'));
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.product = state[sdoNs.USER_SEARCH].$filterProduct;
    this.license = state[sdoNs.USER_SEARCH].$filterLicense;
    this.licenseStatus = state[sdoNs.USER_SEARCH].$filterLicenseStatus;
  }
}

export default UserSearchLicenseFilters;
